import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { BaryComponentHelper } from '../../util/bary-component-helper';
import { SubscribedContainer } from '../../util/subscribed-container';
import { IBaryInput } from '../../../../models/bary-input';
import { Observable } from 'rxjs';
import { OptionType } from '../../../../models/option-type';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'jhi-bary-input-autocomplete',
  templateUrl: './bary-input-autocomplete.component.html',
  styleUrls: ['./bary-input-autocomplete.component.scss'],
})
export class BaryInputAutocompleteComponent extends SubscribedContainer implements OnInit, IBaryInput {
  @Input() id = '';
  @Input() label: string | undefined;
  @Input() name: string | undefined;
  @Input() disabled = false;
  @Input() options!: OptionType[];
  @Input() control: FormControl = new FormControl('');

  @Output() selectEvent = new EventEmitter();

  _innerForm: FormGroup;
  _innerControl: FormControl;
  _options: Observable<OptionType[]>;

  constructor() {
    super();
    this._innerControl = new FormControl('');
    this._innerForm = new FormGroup({
      autocomplete: this._innerControl,
    });
    this._options = this._innerForm.controls['autocomplete'].valueChanges.pipe(
      startWith(''),
      map((value: string) => this.filter(value))
    );
  }

  ngOnInit(): void {
    if (!this.id) {
      this.id = BaryComponentHelper.makeId();
    }
    if (this.control.value) {
      this._innerControl.setValue(this.control.value);
    }
    if (this.control.hasValidator(Validators.required)) {
      this._innerControl.setValidators(Validators.required);
    }
  }

  filter(value: string): OptionType[] {
    const filterValue = value.toLowerCase();
    return this.options.filter((option: OptionType) => option.label.toLowerCase().includes(filterValue));
  }

  select(optionSelected: { text: string; element: any }): void {
    this.control.setValue(optionSelected.element.value);
    this.selectEvent.emit(optionSelected.element.value);
  }
}
